import { useQuery } from '@tanstack/react-query';
import axios, { Axios, AxiosError } from 'axios';
import { Cookies } from 'react-cookie';
import {
  ICardItemDeleteServicePayload,
  ICardItemUpdateServicePayload,
  ICartItemServiceResponse,
} from '../../typescript/interfaces/cart-item.interface';
import { IBaseResponse } from '../../typescript/interfaces/common.interface';
import { useLocation } from 'react-router-dom';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

const axiosInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_CARTITEM_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosInst);

axiosInst.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const cartItemService = async (dataToSend: any) => {
  try {
    if (process.env.REACT_APP_API_BASE_CARTITEM_URL) {
      const response = await axiosInst.post(process.env.REACT_APP_API_BASE_CARTITEM_URL, dataToSend);
      return response.data;
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useGetCartItems = () => {
  const { pathname } = useLocation();
  return useQuery({
    queryKey: ['fetch-cart-items', pathname],
    queryFn: async () => {
      try {
        const cookies = new Cookies();
        const token = cookies.get('session_token');
        if (process.env.REACT_APP_API_BASE_CART_URL) {
          const response = await axios.get(process.env.REACT_APP_API_BASE_CART_URL, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          return response.data;
        }
      } catch (error: unknown) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    refetchOnMount: true,
    gcTime: 0,
  });
};

export const updateCartWithCheckout = async ({ cartData }: any) => {
  for (let i = 0; i < cartData.cartItems?.length; ++i) {
    const obj: any = {};
    const addOnLevelIdsArr = [];
    for (let j = 0; j < cartData.cartItems[i]?.addOns?.length; ++j) {
      const currentAddonItem = cartData.cartItems[i]?.addOns[j];
      if (currentAddonItem?.isInCart) {
        addOnLevelIdsArr.push(currentAddonItem?.variations[currentAddonItem?.currentlySelectedVariationIndex]?.id);
      }
    }
    obj.quantity = cartData.cartItems[i]?.quantity;
    obj.note = cartData.cartItems[i]?.note;
    obj.addon_level_ids = addOnLevelIdsArr;
    const response = await axiosInst.patch(`${cartData.cartItems[i]?.id}`, obj);
    return response.data;
    // const cookies = new Cookies();
    // const token = cookies.get('session_token');

    // if (process.env.REACT_APP_API_BASE_CART_URL) {
    //   await axios.patch(
    //     process.env.REACT_APP_API_BASE_CART_URL,
    //     { note: cartData?.note === null ? '' : cartData?.note },
    //     {
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: `Bearer ${token}`,
    //       },
    //     },
    //   );
    // }
  }
};

export const cartNoteUpdateService = async ({ cartData }: any) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get('session_token');
    if (process.env.REACT_APP_API_BASE_CART_URL) {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_BASE_CART_URL}`,
        { note: cartData?.note === null ? '' : cartData?.note },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const cardItemUpdateService = async ({ _id, ...rest }: ICardItemUpdateServicePayload) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  const response = await axios.patch<ICartItemServiceResponse>(
    `${process.env.REACT_APP_API_BASE_CARTITEM_URL}/${_id}`,
    rest,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response?.data;
};

export const cardItemDeleteService = async ({ _id }: ICardItemDeleteServicePayload) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  const response = await axios.delete<IBaseResponse>(`${process.env.REACT_APP_API_BASE_CARTITEM_URL}/${_id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return response?.data;
};
